import { Box, List } from '@mui/material';
import PryDataLogo from '@assets/global/logoprydata.svg';
import { useLocation, useNavigate } from 'react-router';
import { getFullMenu } from '@/menu/menu.utils';
import MenuItemRecursive from './menuitem';
import { useSyncActiveModule } from '@/hooks/usesyncactivemodule';
import { useAuth } from '@/contexts/auth';

export default function DrawerMenu() {
  const { pathname } = useLocation();
  useSyncActiveModule();
  const navigate = useNavigate();
  const { permissions } = useAuth();
  const menuItems = getFullMenu(pathname, permissions);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 0.95 }}>
        <img src={PryDataLogo} width={181} height={49} />
      </Box>
      <List>
        {menuItems
          .filter((item) => item.permission)
          .map((item) => (
            <MenuItemRecursive
              key={item.name}
              item={item}
              navigate={navigate}
              currentPath={pathname}
              first={true}
            />
          ))}
      </List>
    </Box>
  );
}
